import { render } from "./ChartRadComp.vue?vue&type=template&id=36f58681"
import script from "./ChartRadComp.vue?vue&type=script&lang=js"
export * from "./ChartRadComp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__